import React from 'react';
import { ZapIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function App() {
  return <div className="bg-white w-full" data-id="element-0">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1">
        {/* Header */}
        <header className="mb-8" data-id="element-2">
          <div className="flex items-center justify-between" data-id="element-3">
            <div className="flex items-center space-x-2" data-id="element-4">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4BTpDCmJnTzw6Ty8Pv9W2R/Zestyyy.webp" alt="Zesty Pre-Workout" className="h-16 w-auto" data-id="element-5" />
              <h2 className="text-xl font-bold text-gray-800" data-id="element-6">Zesty</h2>
            </div>
            <button className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-6 rounded-full transition-all flex items-center" data-id="element-7">
              Try Zesty Now <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-8" />
            </button>
          </div>
        </header>
        {/* Hero Section */}
        <div className="mb-12" data-id="element-9">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-10">
            "Why I Traded My 3 Cups of Coffee For One Scoop of This..."
          </h1>
          <div className="text-sm text-gray-600 mb-6" data-id="element-11">
            By Emily R., Contributor | Wellness & Energy | 6 min read
          </div>
          <div className="relative rounded-xl overflow-hidden mb-8" data-id="element-12">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/npjiE2Bn8hMNcnEkrEYNKX/Vibrant_Zesty_Packaging.webp" alt="Zesty Pre-Workout Product" className="w-full h-auto" data-id="element-13" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" data-id="element-14"></div>
          </div>
        </div>
        {/* Main Content */}
        <div className="prose prose-lg max-w-none mb-12" data-id="element-15">
          <p className="lead text-lg text-gray-700 mb-6" data-id="element-16">
            For years, I was that person. You know the one.
          </p>
          <p className="mb-6" data-id="element-17">
            First coffee at 6 AM just to feel human. Second one by 10 AM to
            fight the crash. Third by 2 PM because I was already dead behind the
            eyes.
          </p>
          <p className="mb-6" data-id="element-18">
            Then came the pre-workouts. Gritty, chemical-tasting powders that
            made my heart race like I was having a panic attack. I'd chug them
            down, hoping THIS time would be different.
          </p>
          <p className="mb-6" data-id="element-19">It never was.</p>
          <p className="mb-8" data-id="element-20">
            I was spending $180 a month on energy products that made me feel
            worse than when I started. Anxious. Jittery. Crashing harder every
            single day.
          </p>
          <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6" data-id="element-21">
            The Dirty Secret Your Coffee Shop (And Every Energy Drink Company)
            Hopes You Never Discover
          </h2>
          <div className="my-8" data-id="element-22">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4BTpDCmJnTzw6Ty8Pv9W2R/Zestyyy.webp" alt="Sugary vs Zesty Comparison" className="w-full h-auto rounded-lg shadow-md" data-id="element-23" />
          </div>
          <p className="mb-6" data-id="element-24">They WANT you addicted to the cycle.</p>
          <p className="mb-6" data-id="element-25">
            Think about it. You crash, so you buy more. You build tolerance, so
            you need stronger doses. You can't sleep because you're
            overstimulated, so you're exhausted the next day and need even MORE
            caffeine just to function.
          </p>
          <p className="mb-6" data-id="element-26">It's the perfect business model. For them.</p>
          <p className="mb-6" data-id="element-27">For you? It's a prison.</p>
          <p className="mb-8" data-id="element-28">
            I discovered this the hard way when I calculated my annual spending:
            $2,160 per year on products that were slowly destroying my nervous
            system, my sleep, and my workout performance.
          </p>
          <ul className="space-y-4 my-8" data-id="element-29">
            <li className="flex items-start" data-id="element-30">
              <ZapIcon className="h-5 w-5 text-yellow-500 mt-1 mr-2 flex-shrink-0" data-id="element-31" />
              <span data-id="element-32">You crash, so you buy more.</span>
            </li>
            <li className="flex items-start" data-id="element-33">
              <ZapIcon className="h-5 w-5 text-yellow-500 mt-1 mr-2 flex-shrink-0" data-id="element-34" />
              <span data-id="element-35">You build tolerance, so you need stronger doses.</span>
            </li>
            <li className="flex items-start" data-id="element-36">
              <ZapIcon className="h-5 w-5 text-yellow-500 mt-1 mr-2 flex-shrink-0" data-id="element-37" />
              <span data-id="element-38">You can't sleep because you're overstimulated.</span>
            </li>
            <li className="flex items-start" data-id="element-39">
              <ZapIcon className="h-5 w-5 text-yellow-500 mt-1 mr-2 flex-shrink-0" data-id="element-40" />
              <span data-id="element-41">
                You're exhausted the next day and need even MORE caffeine.
              </span>
            </li>
            <li className="flex items-start" data-id="element-42">
              <ZapIcon className="h-5 w-5 text-yellow-500 mt-1 mr-2 flex-shrink-0" data-id="element-43" />
              <span data-id="element-44">The cycle repeats, draining your wallet and health.</span>
            </li>
          </ul>
          <p className="mb-8" data-id="element-45">That's when everything changed.</p>
          <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6 flex items-center" data-id="element-46">
            The 3-System Discovery That Broke My Caffeine Prison (And Tripled My
            Gym Performance)
          </h2>
          <div className="bg-yellow-50 p-6 rounded-xl my-8 border border-yellow-100" data-id="element-47">
            <p className="font-medium text-gray-800 mb-5" data-id="element-48">
              My friend Jake – who's one of those annoyingly energetic people
              who seems to have it all figured out – watched me slam my third
              coffee before noon and said something that stopped me cold:
            </p>
            <p className="text-gray-700" data-id="element-49">
              "What if I told you there's a way to get MORE energy, better
              focus, and incredible workouts... using LESS stimulants than that
              single cup of coffee?"
            </p>
          </div>
          <p className="mb-6" data-id="element-50">I laughed. Then I saw his gym numbers.</p>
          <p className="mb-6" data-id="element-51">
            This guy was hitting PRs every week. His energy was rock-steady from
            morning till night. No jitters. No crashes. No 3 PM sugar cravings.
          </p>
          <p className="mb-6" data-id="element-52">
            He introduced me to something completely different. Not another
            high-caffeine death blend. Not another sugar-loaded energy drink.
          </p>
          <p className="font-semibold text-gray-800 mb-5" data-id="element-53">
            A 3-System approach that works WITH your body instead of against it:
          </p>
          <div className="space-y-8 my-8" data-id="element-54">
            <div className="bg-white shadow-sm rounded-lg p-5 border border-gray-100" data-id="element-55">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-56">
                SYSTEM 1: LASER FOCUS
              </h3>
              <h4 className="text-lg font-medium text-gray-800 mb-3" data-id="element-57">
                The "Clear Mind Matrix"
              </h4>
              <p className="mb-4" data-id="element-58">
                Instead of drowning your brain in caffeine, this system creates
                CALM focus:
              </p>
              <ul className="space-y-3" data-id="element-59">
                <li className="flex items-start" data-id="element-60">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-61" />
                  <span data-id="element-62">
                    L-Theanine (100mg) – The secret monks use for alert
                    meditation
                  </span>
                </li>
                <li className="flex items-start" data-id="element-63">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-64" />
                  <span data-id="element-65">
                    Alpha-GPC (600mg) – Clinical-dose brain fuel that actually
                    FEEDS your neurons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-66">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-67" />
                  <span data-id="element-68">
                    N-Acetyl Tyrosine (1g) – Mental clarity that gets STRONGER
                    under stress
                  </span>
                </li>
              </ul>
              <p className="mt-4 font-medium" data-id="element-69">
                The result? Your mind becomes a laser. Distractions fade. That
                scattered, anxious feeling disappears. You enter what athletes
                call "the zone."
              </p>
            </div>
            <div className="bg-white shadow-sm rounded-lg p-5 border border-gray-100" data-id="element-70">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-71">
                SYSTEM 2: CLEAN ENERGY
              </h3>
              <h4 className="text-lg font-medium text-gray-800 mb-3" data-id="element-72">
                The "Steady State Engine"
              </h4>
              <p className="mb-4" data-id="element-73">
                This is where the magic happens. Instead of the caffeine
                spike-and-crash:
              </p>
              <ul className="space-y-3" data-id="element-74">
                <li className="flex items-start" data-id="element-75">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-76" />
                  <span data-id="element-77">
                    Caffeine Anhydrous (200mg) – Less than your morning coffee,
                    but BETTER
                  </span>
                </li>
                <li className="flex items-start" data-id="element-78">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-79" />
                  <span data-id="element-80">
                    Theobromine (100mg) – The "feel good" compound from
                    chocolate that lasts for HOURS
                  </span>
                </li>
                <li className="flex items-start" data-id="element-81">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-82" />
                  <span data-id="element-83">
                    English Walnut (125mg) + Schisandra (300mg) – The
                    anti-fatigue pump enhancer that floods your muscles with
                    blood while blocking the tiredness that kills your best sets
                  </span>
                </li>
              </ul>
              <p className="mt-4 font-medium" data-id="element-84">
                The difference? Energy that builds gradually, peaks smoothly,
                and fades naturally. No crash. No anxiety. Just sustained power.
              </p>
            </div>
            <div className="bg-white shadow-sm rounded-lg p-5 border border-gray-100" data-id="element-85">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-86">
                SYSTEM 3: OPTIMAL HYDRATION
              </h3>
              <h4 className="text-lg font-medium text-gray-800 mb-3" data-id="element-87">
                The "Performance Amplifier"
              </h4>
              <p className="mb-4" data-id="element-88">
                Here's where most pre-workouts completely miss the mark:
              </p>
              <ul className="space-y-3" data-id="element-89">
                <li className="flex items-start" data-id="element-90">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-91" />
                  <span data-id="element-92">
                    L-Citrulline Malate (6-8g) – Full clinical dose (most use
                    2-3g and wonder why you don't feel it)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-93">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-94" />
                  <span data-id="element-95">
                    Beta-Alanine (3.2g) + Betaine (2.5g) – Properly dosed
                    endurance stack (not the sprinkle most brands use)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-96">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-97" />
                  <span data-id="element-98">
                    Complete Electrolyte Matrix – Pink Himalayan Salt, Sea Salt,
                    Potassium – the hydration secret that separates good days
                    from great days
                  </span>
                </li>
              </ul>
              <p className="mt-4 font-medium" data-id="element-99">
                The payoff? Every rep feels better. Every set hits harder.
                Recovery happens faster.
              </p>
            </div>
            <div className="bg-white shadow-sm rounded-lg p-5 border border-gray-100" data-id="element-100">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-101">
                Why This Works When Everything Else Failed (The Science They
                Don't Want You To Know)
              </h3>
              <p className="mb-4" data-id="element-102">
                Most energy products are built on a lie: "More stimulants =
                better performance."
              </p>
              <p className="mb-4" data-id="element-103">
                That's like saying driving faster always gets you there quicker.
                Sometimes you just crash.
              </p>
              <p className="mb-4" data-id="element-104">
                The 3-System approach is based on a different principle:
                Synergy.
              </p>
              <p className="mb-4" data-id="element-105">
                When you combine the right ingredients at the right doses,
                something magical happens. The whole becomes greater than the
                sum of its parts.
              </p>
              <ul className="space-y-3" data-id="element-106">
                <li className="flex items-start" data-id="element-107">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-108" />
                  <span data-id="element-109">
                    L-Theanine makes caffeine smooth instead of jittery
                  </span>
                </li>
                <li className="flex items-start" data-id="element-110">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-111" />
                  <span data-id="element-112">
                    Adaptogens prevent the stress response that causes crashes
                  </span>
                </li>
                <li className="flex items-start" data-id="element-113">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-114" />
                  <span data-id="element-115">
                    Electrolytes ensure every system in your body functions
                    optimally
                  </span>
                </li>
                <li className="flex items-start" data-id="element-116">
                  <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-117" />
                  <span data-id="element-118">
                    Nootropics enhance the mental benefits without adding more
                    stimulants
                  </span>
                </li>
              </ul>
              <p className="mt-4" data-id="element-119">
                Third-party tested. Clinical doses. No proprietary blends hiding
                tiny amounts.
              </p>
              <p className="mt-2 font-medium" data-id="element-120">
                This isn't another "kitchen sink" formula with 47 ingredients.
                It's precision engineering.
              </p>
            </div>
          </div>
          <p className="font-medium text-gray-800 mb-5" data-id="element-121">
            But here's the real kicker...
          </p>
          <p className="text-gray-700 italic mb-8" data-id="element-122">
            The synergistic effect of these systems creates an experience that's
            more than just energy - it's transformation.
          </p>
          {/* Mid-page CTA */}
          <div className="bg-yellow-50 rounded-lg p-6 border border-yellow-100 my-10" data-id="element-123">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-124">
              Ready to Experience the 3-System Energy Transformation?
            </h3>
            <p className="text-gray-700 mb-5" data-id="element-125">
              Join thousands who've already broken free from the caffeine prison
              and upgraded their energy, focus, and workout performance.
            </p>
            <div className="text-center" data-id="element-126">
              <button className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full transition-all inline-flex items-center" data-id="element-127">
                Yes! I Want Better Energy & Focus{' '}
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-128" />
              </button>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6" data-id="element-129">
            My First 7 Days: The Transformation I Never Saw Coming
          </h2>
          <p className="mb-6" data-id="element-130">
            I was skeptical. I'd tried so many pre-workouts, so many energy
            drinks. But this was different from the very first scoop. Here's
            what shifted in just my first week:
          </p>
          <div className="overflow-x-auto my-8" data-id="element-131">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-132">
              <thead className="bg-gray-50" data-id="element-133">
                <tr data-id="element-134">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-135">
                    Day
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-136">
                    Result
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-137">
                <tr data-id="element-138">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-139">
                    1
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-140">
                    Hit a squat PR I'd been chasing for months. No shaking
                    hands. No heart palpitations. Just... strength.
                  </td>
                </tr>
                <tr data-id="element-141">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-142">
                    2
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-143">
                    3 PM came and went. No crash. No sugar cravings. I worked
                    until 7 PM with laser focus.
                  </td>
                </tr>
                <tr data-id="element-144">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-145">
                    3
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-146">
                    Slept like a baby despite having energy all day. Woke up
                    naturally at 6 AM without an alarm.
                  </td>
                </tr>
                <tr data-id="element-147">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-148">
                    4
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-149">
                    Ran 5 miles and felt like I could keep going. My mind was as
                    strong as my body.
                  </td>
                </tr>
                <tr data-id="element-150">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-151">
                    5
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-152">
                    Realized I hadn't touched coffee in 3 days. Didn't miss it.
                    Didn't need it.
                  </td>
                </tr>
                <tr data-id="element-153">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-154">
                    6
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-155">
                    My workout partner asked what I was taking. My bench press
                    had jumped 15 pounds in less than a week.
                  </td>
                </tr>
                <tr data-id="element-156">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-157">
                    7
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-158">
                    The lightbulb moment: I wasn't tired. I was just using the
                    wrong fuel.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mb-6" data-id="element-159">
            Three weeks into my trial with the Zesty formula, I realized I was
            saving over $100/month compared to what I used to spend — and
            getting far better results.
          </p>
          <p className="mb-8" data-id="element-160">But the real change? I got my life back.</p>
          <p className="mb-6" data-id="element-161">
            No more afternoon zombification. No more lying awake wired but
            exhausted. No more embarrassing crashes during important meetings.
          </p>
          <p className="mb-8" data-id="element-162">
            Just clean, reliable energy that worked ALL DAY.
          </p>
          <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6" data-id="element-163">
            What Others Are Saying (And Why Big Energy Companies Are Terrified)
          </h2>
          {/* Testimonials with background image */}
          <div className="relative my-8 rounded-xl overflow-hidden" data-id="element-164">
            <div className="absolute inset-0 z-0" data-id="element-165">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fgqPhEWrifDseaM7xQFqu6/assets_task_01k0rfvr68f4grkbc1t7sq1gnb_1753168782_img_1.webp" alt="Zesty Energy Background" className="w-full h-full object-cover opacity-90" data-id="element-166" />
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/15 via-yellow-500/20 to-yellow-600/30" data-id="element-167"></div>
            </div>
            <div className="relative z-10 p-8" data-id="element-168">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-169">
                <div className="bg-white/95 p-5 rounded-lg shadow-lg border border-gray-100" data-id="element-170">
                  <p className="text-gray-700 italic mb-4" data-id="element-171">
                    "I was spending $200+ monthly on coffee and energy drinks.
                    Now I have steady energy all day, sleep better at night, and
                    my lifts have increased 20%. This isn't just a supplement -
                    it's freedom."
                  </p>
                  <p className="text-gray-600 font-medium" data-id="element-172">
                    – Marcus T., Austin TX
                  </p>
                </div>
                <div className="bg-white/95 p-5 rounded-lg shadow-lg border border-gray-100" data-id="element-173">
                  <p className="text-gray-700 italic mb-4" data-id="element-174">
                    "Three months ago I couldn't make it through a 2 PM meeting
                    without nodding off. Now I'm the most energetic person in
                    the room. My productivity has doubled and my mood is
                    consistently positive."
                  </p>
                  <p className="text-gray-600 font-medium" data-id="element-175">
                    – Sarah M., New York NY
                  </p>
                </div>
                <div className="bg-white/95 p-5 rounded-lg shadow-lg border border-gray-100" data-id="element-176">
                  <p className="text-gray-700 italic mb-4" data-id="element-177">
                    "I've tried every pre-workout on the market. This is the
                    first one that makes me feel BETTER after my workout than
                    before. The pumps are insane and recovery is lightning
                    fast."
                  </p>
                  <p className="text-gray-600 font-medium" data-id="element-178">
                    – Jake R., Denver CO
                  </p>
                </div>
                <div className="bg-white/95 p-5 rounded-lg shadow-lg border border-gray-100" data-id="element-179">
                  <p className="text-gray-700 italic mb-4" data-id="element-180">
                    "The big energy companies hate testimonials like these. Why?
                    Because once people discover clean energy actually exists,
                    they never go back to the crash-and-burn cycle."
                  </p>
                  <p className="text-gray-600 font-medium" data-id="element-181">
                    – Industry Insider
                  </p>
                </div>
              </div>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6" data-id="element-182">
            WARNING: This Isn't For Everyone (Please Read Carefully)
          </h2>
          <p className="mb-6" data-id="element-183">
            Let me be brutally honest. If you're perfectly happy spending $150+
            monthly on products that make you anxious, crash your energy, and
            taste like chemical waste... stick with what you're doing.
          </p>
          <p className="mb-6" data-id="element-184">
            If you enjoy the roller coaster of high-stim addiction, the
            afternoon crashes, and the 11 PM wide-awake-but-exhausted
            syndrome... this isn't for you.
          </p>
          <p className="font-medium text-gray-800 mb-5" data-id="element-185">
            But if you're ready to:
          </p>
          <ul className="space-y-4 my-8" data-id="element-186">
            <li className="flex items-start" data-id="element-187">
              <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-188" />
              <span data-id="element-189">
                Experience energy that feels NATURAL instead of forced
              </span>
            </li>
            <li className="flex items-start" data-id="element-190">
              <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-191" />
              <span data-id="element-192">
                Get MORE done with LESS caffeine than you're using now
              </span>
            </li>
            <li className="flex items-start" data-id="element-193">
              <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-194" />
              <span data-id="element-195">
                Have workouts that leave you feeling confident instead of
                drained
              </span>
            </li>
            <li className="flex items-start" data-id="element-196">
              <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-197" />
              <span data-id="element-198">Sleep better despite having energy all day</span>
            </li>
            <li className="flex items-start" data-id="element-199">
              <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-200" />
              <span data-id="element-201">
                Stop wasting money on products that work against your body
              </span>
            </li>
            <li className="flex items-start" data-id="element-202">
              <CheckCircleIcon className="h-5 w-5 text-green-500 mt-1 mr-2 flex-shrink-0" data-id="element-203" />
              <span data-id="element-204">Finally break free from the stimulant prison</span>
            </li>
          </ul>
          <p className="italic text-gray-700 mb-6" data-id="element-205">
            Then this could be the most important decision you make this year.
          </p>
          <p className="mb-6" data-id="element-206">
            I went from caffeine-dependent and crash-prone to having the most
            consistent energy and best workouts of my life. My focus is
            unshakeable. My mood is stable. My performance keeps improving.
          </p>
          <p className="mb-8" data-id="element-207">And it all started with one simple decision...</p>
        </div>
        {/* CTA Section */}
        <div className="bg-yellow-50 rounded-2xl p-8 border border-yellow-100 mb-12" data-id="element-208">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-209">
            Your Escape Route: The 30-Day Energy Transformation Challenge
          </h2>
          <p className="text-gray-700 mb-8" data-id="element-210">Here's the situation:</p>
          <p className="text-gray-700 mb-8" data-id="element-211">
            This is Zesty's very first limited launch to the public. Only 100
            units are available — and once they're gone, they're gone.
          </p>
          <p className="text-gray-700 mb-8" data-id="element-212">
            We're keeping this first launch small so we can:
          </p>
          <ul className="list-disc pl-8 space-y-4 mb-8" data-id="element-213">
            <li className="text-gray-700" data-id="element-214">
              Get honest feedback from our first customers
            </li>
            <li className="text-gray-700" data-id="element-215">
              Support each subscriber personally as we grow
            </li>
          </ul>
          <p className="text-gray-700 mb-8" data-id="element-216">
            We're not planning another production run for at least 8–10 weeks,
            so this may be your only chance for months to try Zesty.
          </p>
          <div className="my-8 flex justify-center" data-id="element-217">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bP2AN6jA72YrfQVHAEGUSa/assets_task_01k17433wbe7b8fhj775erf34j_1753659743_img_1.webp" alt="Zesty Pre-Workout Product" className="w-3/4 h-auto rounded-lg shadow-lg" data-id="element-218" />
          </div>
          <p className="text-gray-700 mb-8" data-id="element-219">That means this is your window.</p>
          <p className="text-gray-700 mb-8" data-id="element-220">
            But I'm not going to pressure you with fake scarcity or countdown
            timers. Instead, I'm going to make you an offer so risk-free, you'd
            be crazy not to try it:
          </p>
          <div className="bg-white rounded-xl p-6 shadow-sm mb-8" data-id="element-221">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-222">
              Subscribe to Zesty – Just $39.95/month
            </h3>
            <p className="text-sm text-yellow-600 font-medium mb-6" data-id="element-223">
              Limited availability — join before we sell out
            </p>
            <h4 className="font-semibold text-gray-800 mb-4" data-id="element-224">
              Here's what you get:
            </h4>
            <div className="space-y-4" data-id="element-225">
              <div className="flex items-start" data-id="element-226">
                <span className="text-yellow-500 font-bold text-2xl mr-3 animate-pulse" data-id="element-227">
                  •
                </span>
                <div data-id="element-228">
                  <p className="font-medium text-yellow-600" data-id="element-229">
                    <span className="font-bold" data-id="element-230">EXCLUSIVE:</span> Free Zesty
                    Shaker Bottle (First 100 subscribers only — Never sold
                    separately. Never repeated.)
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-231">
                <span className="text-yellow-500 font-bold text-2xl mr-3" data-id="element-232">
                  •
                </span>
                <div data-id="element-233">
                  <p className="font-medium" data-id="element-234">
                    Monthly Supply of Zesty (full 3-system formula)
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-235">
                <span className="text-yellow-500 font-bold text-2xl mr-3" data-id="element-236">
                  •
                </span>
                <div data-id="element-237">
                  <p className="font-medium" data-id="element-238">
                    Exclusive Subscriber-Only Pricing
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-239">
                <span className="text-yellow-500 font-bold text-2xl mr-3" data-id="element-240">
                  •
                </span>
                <div data-id="element-241">
                  <p className="font-medium" data-id="element-242">Free Priority Shipping</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-243">
                <span className="text-yellow-500 font-bold text-2xl mr-3" data-id="element-244">
                  •
                </span>
                <div data-id="element-245">
                  <p className="font-medium" data-id="element-246">
                    First Access to Restocks & Limited Drops
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-6 border-t border-gray-100 pt-6" data-id="element-247">
              <div className="flex justify-between items-center mb-2" data-id="element-248">
                <span className="font-medium text-gray-700" data-id="element-249">
                  Regular Price:
                </span>
                <span className="font-bold text-gray-900 line-through" data-id="element-250">
                  $67
                </span>
              </div>
              <div className="flex justify-between items-center mb-2" data-id="element-251">
                <span className="font-bold text-xl" data-id="element-252">Subscriber Price:</span>
                <span className="font-bold text-2xl text-yellow-600" data-id="element-253">
                  Just $39.95/month
                </span>
              </div>
              <p className="text-gray-600 text-center italic mt-2" data-id="element-254">
                No crash. No junk. No contracts. Cancel anytime.
              </p>
            </div>
          </div>
          <p className="text-gray-700 mb-8" data-id="element-255">
            Try it for 30 days. If it doesn't deliver better energy, focus, and
            workouts - you'll get a full refund. No fine print.
          </p>
          <div className="text-center" data-id="element-256">
            <button className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-4 px-8 rounded-full text-lg transition-all inline-flex items-center" data-id="element-257">
              SUBSCRIBE NOW - JUST $39.95/MONTH{' '}
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-258" />
            </button>
            <p className="text-sm text-gray-600 mt-4" data-id="element-259">
              Limited availability — subscribe now before we sell out!
            </p>
          </div>
        </div>
        {/* Added pricing image above guarantee footer */}
        <div className="flex justify-center mb-10" data-id="element-260">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pf9MqoXsnMrEn2J1W5WuJP/assets_task_01k15v9fetf1mavk2bzvdepbbg_1753616974_img_1.webp" alt="Zesty Pricing Options" className="w-full h-auto rounded-lg shadow-lg" data-id="element-261" />
        </div>
        {/* Guarantee Footer */}
        <div className="border-t border-gray-200 pt-8" data-id="element-262">
          <div className="flex items-center justify-center mb-4" data-id="element-263">
            <CheckCircleIcon className="h-8 w-8 text-green-500 mr-2" data-id="element-264" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-265">
              30-Day Money-Back Guarantee
            </h3>
          </div>
          <p className="text-center text-xs text-gray-500 mt-4" data-id="element-266">
            These testimonials are based on early user experiences or product
            trials. Zesty is currently in limited launch phase with only 100
            units available.
          </p>
        </div>
      </div>
    </div>;
}